"use client";

import { useCallback } from "react";
import { useOptionalI18n } from "./LocaleProvider";
import { DEFAULT_APP_LOCALE } from "./locales";
import { translateTimePilotMessage } from "./timepilotCatalogs";

export type TranslateFn = (key: string, values?: Record<string, string | number>) => string;

/**
 * Translate from the TimePilot catalogs in the active app locale. Falls back to
 * English when no LocaleProvider is mounted, so TimePilot components that also
 * render on routes outside `Main` keep working instead of throwing.
 */
export function useTimePilotT(): TranslateFn {
  const locale = useOptionalI18n()?.locale ?? DEFAULT_APP_LOCALE;
  return useCallback(
    (key: string, values?: Record<string, string | number>) =>
      translateTimePilotMessage(locale, key, values),
    [locale],
  );
}
